module.exports = __webpack_public_path__ + "public/images/program/program-8.6a0010064caa414159cf71787dc8a388.png";